package com.cybersoftsolution.cybersoftsolutionweb.styles

import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val LoginButtonStyle = CssStyle {

    base {
        Modifier
            .border(
                width = 2.px,
                style = LineStyle.Solid,
//           color = Theme.Primary.rgb
                color = Colors.Transparent
            )
            .outline(
                width = 0.px,
                style = LineStyle.None,
                color = Colors.Transparent
            )
            .backgroundColor(Theme.PrimaryButton.rgb)
            .transition(
                Transition.of(
                    property = TransitionProperty.All ,
                    duration = 100.ms,
                    timingFunction = null,
                    delay = null
                )
            )
    }
    hover {

        Modifier
            .backgroundColor(Theme.PrimaryButton.rgb)
            .border(
            width = 2.px,
            style = LineStyle.Solid,
            color = Theme.Primary.rgb
            )
            .outline(
                width = 0.px,
                style = LineStyle.None,
                color = Colors.Transparent
            )
            .transition(
                Transition.of(
                    property = TransitionProperty.All ,
                    duration = 100.ms,
                    timingFunction = null,
                    delay = null
                )
            )
    }





//    focus {
//        Modifier.border(
//            width = 2.px,
//            style = LineStyle.Solid,
//            color = Theme.Primary.rgb
//        )
//            .outline(
//                width = 0.px,
//                style = LineStyle.None,
//                color = Colors.Transparent
//            )
//    }
}




